import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { InterfaceService } from "@app/interfaces";
import * as moment from "moment";
import { TimelineDatePipe } from '@app/pipes/timeline-date.pipe';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../pipes/timeline-date.pipe";
var TimelineService = /** @class */ (function (_super) {
    tslib_1.__extends(TimelineService, _super);
    function TimelineService(http, timelineDateTime) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.timelineDateTime = timelineDateTime;
        _this.vehicleSearchActivity = new BehaviorSubject('');
        _this.vehicleSearchActivity$ = _this.vehicleSearchActivity.asObservable();
        _this.vehicleTimelineRefresh = new BehaviorSubject('');
        _this.vehicleTimelineRefresh$ = _this.vehicleTimelineRefresh.asObservable();
        _this.fileTypeGroups = {
            image: ['jpg', 'png', 'gif', 'jpeg', 'heic', 'heif', 'PNG', 'JPEG', 'JPG', 'GIF'],
            pdf: ['pdf'],
            csv: ['csv', 'xml'],
            word_document: ['doc', 'docx', 'txt', 'odt'],
            excel: ['xls', 'xlsx', 'ods', 'xlr'],
            audio: ['mp3', 'mpa', 'ogg', 'mid', 'midi'],
            video: ['avi', 'flv', 'mov', 'mp4', 'mpg', 'mpeg'],
            compressed: ['7z', 'rar', 'zip', 'tar.gz'],
            power_point: ['odp', 'pps', 'ppt', 'pptx'],
        };
        return _this;
    }
    TimelineService.prototype.getTimelineData = function (screen, primaryId, filters, portalAccess) {
        return this.http.get(this.getApiUrl("shared/getTimelineData/" + screen + "/" + primaryId + "?portalAccess=" + portalAccess), filters);
    };
    TimelineService.prototype.checkTimeLineHeaderDate = function (date) {
        var value = moment(date).calendar(null, {
            lastDay: '[Yesterday]',
            sameDay: '[Today]',
            nextDay: '[Tomorrow]'
        });
        if (value == 'Today' || value == 'Tomorrow' || value == 'Yesterday') {
            return value;
        }
        else {
            return null;
        }
    };
    TimelineService.prototype.convertTimeLineHeaderDate = function (date) {
        return this.timelineDateTime.transform(date, 'date');
    };
    TimelineService.prototype.convertTimeLineDateTime = function (date, type) {
        return this.timelineDateTime.transform(date, type ? type : 'datetime');
    };
    TimelineService.prototype.getDateDifference = function (date) {
        var now = moment(new Date());
        var fromDate = moment(date);
        var duration = moment.duration(fromDate.diff(now));
        return duration.humanize(true);
    };
    TimelineService.prototype.diaryDateTimeRange = function (fromDateTime, toDateTime, allDay, isSpecialEvent, duration) {
        fromDateTime = moment.utc(fromDateTime);
        toDateTime = moment.utc(toDateTime);
        var value = '';
        if (allDay === false) {
            if (isSpecialEvent) {
                value = this.timelineDateTime.transform(fromDateTime, 'diarydate') + ' ' + duration + ' (' + this.timelineDateTime.transform(fromDateTime, 'diarytime') + ' - ' + this.timelineDateTime.transform(toDateTime, 'diarytime') + ')';
            }
            else {
                value = this.timelineDateTime.transform(fromDateTime, 'diarydate') + ' (' + this.timelineDateTime.transform(fromDateTime, 'diarytime') + ' - ' + this.timelineDateTime.transform(toDateTime, 'diarytime') + ')';
            }
        }
        else {
            value = this.timelineDateTime.transform(fromDateTime, 'diarydate') + ' ' + allDay;
        }
        return value;
    };
    TimelineService.prototype.getFileGroup = function (fileType) {
        var fileGroup = 'unknown';
        fileType = fileType.toLowerCase(); // Convert fileType to lowercase
        for (var key in this.fileTypeGroups) {
            if (this.fileTypeGroups.hasOwnProperty(key)) {
                var value = this.fileTypeGroups[key];
                if (value.indexOf(fileType) != -1) {
                    fileGroup = key;
                    break;
                }
            }
        }
        return fileGroup;
    };
    TimelineService.prototype.convertTimeLineScheduledDateTime = function (date) {
        var normalized = this.normalizeTimelineDate(date);
        if (typeof normalized === 'string' && normalized.indexOf(' ') !== -1) {
            normalized = normalized.replace(' ', 'T');
        }
        // Do not force UTC for scheduled activity display; value is already in intended local context.
        return this.timelineDateTime.transform(normalized, 'datetime');
    };
    /**
     * Normalize date from API: PHP serialized DateTime is { date, timezone_type, timezone }.
     * Return the date string so pipes/moment receive a parseable value.
     */
    TimelineService.prototype.normalizeTimelineDate = function (value) {
        if (value != null && typeof value === 'object' && value.hasOwnProperty('date')) {
            return value.date;
        }
        return value;
    };
    TimelineService.prototype.getJobData = function () {
        return this.JobsTimelineData;
    };
    TimelineService.prototype.setJobData = function (data) {
        this.JobsTimelineData = data;
    };
    TimelineService.prototype.getVehicleTimeline = function (id, page, limit, filters) {
        if (filters === void 0) { filters = []; }
        var payload = {
            id: id,
            page: page,
            limit: limit,
            filters: filters
        };
        if (filters && filters.length) {
            payload.filters = filters;
        }
        var url = this.getFleetApiUrl("getVehicleTimeline");
        return this.http.post(url, payload);
    };
    TimelineService.prototype.getJobPartsDetails = function (ids) {
        var url = this.getApiUrl("job_parts_details/" + ids);
        return this.http.get(url);
    };
    TimelineService.prototype.timelineSearchActivity = function (data) {
        this.vehicleSearchActivity.next(data);
    };
    TimelineService.prototype.saveFilesData = function (jobId, files, shareOnMobile, shareOnPortal, deleteIds, id, selectedTags) {
        console.log(jobId, files, shareOnMobile, shareOnPortal, deleteIds, id, selectedTags);
        var formData = new FormData();
        if (files != undefined) {
            for (var i = 0; i < files.length; i++) {
                formData.append("file" + i, files[i]);
            }
        }
        formData.append("shareOnMobile", shareOnMobile);
        formData.append("shareOnPortal", shareOnPortal);
        if (deleteIds) {
            formData.append("deleteIds", deleteIds);
        }
        if (id) {
            formData.append("id", id);
        }
        if (selectedTags) {
            formData.append("selectedTags", JSON.stringify(selectedTags));
        }
        var url = this.getApiUrl("upload_job_files/" + jobId);
        return this.http.post(url, formData);
    };
    TimelineService.prototype.getJobStatusDetailsNew = function (jobId) {
        return this.http.get(this.getApiUrl("job_status_details/" + jobId));
    };
    TimelineService.prototype.getJobPartsPoDetails = function (partId, id, jobId) {
        var url = this.getApiUrl("getJobPartViewList?partId=" + partId + "&id=" + id + "&jobId=" + jobId + "&status=On_Order");
        return this.http.get(url);
    };
    TimelineService.prototype.getDefectStatus = function (defectId) {
        var url = this.getJobApiUrl("opportunities/defects/" + defectId);
        return this.http.get(url);
    };
    TimelineService.prototype.setVehicleTimelineRefresh = function (data) {
        this.vehicleTimelineRefresh.next(data);
    };
    TimelineService.ngInjectableDef = i0.defineInjectable({ factory: function TimelineService_Factory() { return new TimelineService(i0.inject(i1.HttpClient), i0.inject(i2.TimelineDatePipe)); }, token: TimelineService, providedIn: "root" });
    return TimelineService;
}(InterfaceService));
export { TimelineService };
